import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useSignOut from '@/hooks/users/use-sign-out';
import type { RespondedType, ResponseError } from '@/models/response';
import { useAuthStore } from '@/stores/auth';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useCancelAccount() {
  const { t } = useTranslation();
  const { disposeServices } = useSignOut();

  return useMutation<RespondedType, ResponseError>({
    mutationKey: ['/CancelAccount'],
    mutationFn: () => fetcher('/CancelAccount', undefined, { validResponseCodes: [0] }),
    onSuccess: () => {
      addToast({
        type: 'success',
        message: t('personal-info.delete-account.success'),
      });
      disposeServices();
      useAuthStore.getState().stop(false);
    },
    onError: () => {
      addToast({
        type: 'error',
        message: t('personal-info.delete-account.error'),
      });
    },
  });
}
